import ArrowIcon from "theme/components/icons/ArrowIcon";
import Link from "core-web/components/Link";
import PropTypes from "prop-types";
import React from "react";
import ThemeButton from "theme/components/buttons/ThemeButton";
import colors from "theme/config/colors";
import styleObjectToProps from "core-web/utils/styleObjectToProps";
import styled from "theme/libs/styled";
import { useTranslation } from "react-i18next";

const ButtonWrapper = styled("div")`
    position: absolute;
    bottom: 8px;
    right: 8px;
    width: auto;
    min-width: 0;
    max-width: 32px;
    z-index: 2;
    transition:
        min-width ${({ theme }) => theme.transitions.primarySlow},
        max-width ${({ theme }) => theme.transitions.primarySlow};

    ${({ theme }) => theme.above.desktopSm} {
        right: 12px;
        bottom: 12px;
        max-width: 40px;
    }

    ${({ theme }) => theme.media.hover} {
        &:hover {
            max-width: 120px;
        }
    }
`;

const Flex = styled("div")`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100%;
`;

const PromptText = styled("span")`
    color: ${({ theme }) => theme.colors.black};
    margin-right: 20px;
    white-space: nowrap;
    opacity: 0;
    transition: opacity 100ms ease;
    pointer-events: none;

    ${({ theme }) => theme.media.hover} {
        .btn-wrapper:hover & {
            transition: opacity 100ms ease 100ms;
            opacity: 1;
        }
    }
`;

const IconWrapper = styled("div")`
    display: flex;
    justify-content: center;
    position: absolute;
    right: -3px;
`;

const textStyles = styleObjectToProps("Buenos Aires/14-120 Regular");

const GoToProductPageButton = ({ url, buttonTheme }) => {
    const { t } = useTranslation();

    return (
        <ButtonWrapper className="btn-wrapper">
            <ThemeButton
                disableHover
                buttonTheme={buttonTheme}
                width="100%"
                as={url && Link}
                to={url && url}
                size={["sm", null, null, null, null, "md"]}
            >
                <Flex>
                    <PromptText {...textStyles}>{t("product_card.shop_now")}</PromptText>
                    <IconWrapper>
                        <ArrowIcon color={colors.black} direction="right" />
                    </IconWrapper>
                </Flex>
            </ThemeButton>
        </ButtonWrapper>
    );
};

GoToProductPageButton.propTypes = {
    buttonTheme: PropTypes.string,
    url: PropTypes.string,
};

GoToProductPageButton.defaultProps = {
    buttonTheme: "white_solid",
    url: null,
};

export default GoToProductPageButton;
